import React from "react";
import "./Rolling.css";
import Pagination from "./Pagination";
import { useSelector } from "react-redux";

function RollingTable({
  dataItem,
  userData,
  setCurrentPage,
  currentPage,
  pagesData,
  getRollingReserveData,
}) {
  const role = useSelector((store) => store.userReducer.role);
  let token = useSelector((store) => store.userReducer.token);

  return (
    <div className="table-main-report">
      <table className="table-user-management" id="transaction-table">
        <thead className="table-user-report">
          <tr>
            {(role == "super" ||
              role === "operation" ||
              role === "subSuper") && (
              <td>
                <p className="user-table-head-report">Business Name</p>
              </td>
            )}

            <td>
              <p className="user-table-head-report">OrderId</p>
            </td>
            <td>
              <p className="user-table-head-report">TransactionId</p>
            </td>
            <td>
              <p className="user-table-head-report">Amount(₹)</p>
            </td>
            <td>
              <p className="user-table-head-report">Updated Date</p>
            </td>
            <td>
              <p className="user-table-head-report">Days Left</p>
            </td>
            <td>
              <p className="user-table-head-report">Status</p>
            </td>
          </tr>
        </thead>

        <tbody>
          {dataItem &&
            dataItem.length > 0 &&
            dataItem.map((item, i) => {
              // console.log("itemitemitemitemitem::::",item)
              const dateString = item.createdAt;
              const date = new Date(dateString);
              const day = date.getDate();
              const month = date.getMonth() + 1;
              const year = date.getFullYear();
              const hours = date.getHours();
              const minutes = date.getMinutes();
              const seconds = date.getSeconds();
              const formattedDate = `${day}-${month}-${year}`;
              const formattedTime = `${hours}:${minutes}:${seconds}`;
              return (
                <tr key={i} className="user-table-head-report">
                  {(role === "super" ||
                    role === "operation" ||
                    role === "subSuper") && (
                    <td>
                      <p className="table-user-data-report order-break">
                        {userData &&
                          userData.length > 0 &&
                          userData
                            .map((user) =>
                              user.id === item.userId
                                ? user?.alias || user?.id
                                : null
                            )
                            .filter((name) => name)}{" "}
                      </p>
                    </td>
                  )}
                  <td>
                    <p className="table-user-data-report order-break">
                      {item?.orderId || "0"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {item?.transactionId || "0"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {Number(item?.amount).toFixed(2) || "0.00"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {formattedDate || "0"} {formattedTime || "0"}
                    </p>
                  </td>
                  <td>
                    <p className="table-user-data-report order-break">
                      {item?.days < 0 ? "0" : item?.days || "0"}
                    </p>
                  </td>
                  <td>
                    <p
                      className={`table-user-data-report-1 ${
                        item.status == false && item?.days < 0
                          ? "status-pending"
                          : item.status == true
                            ? "status-completed"
                            : ""
                      }`}
                    >
                      {item.status == false ? "Pending" : "Completed" || "0"}
                    </p>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      {dataItem?.length > 0 && (
        <div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pagesData={pagesData}
            getRollingReserveData={getRollingReserveData}
            token={token}
          />
        </div>
      )}
    </div>
  );
}

export default RollingTable;
